import { render, staticRenderFns } from "./Danzhangtihuan.vue?vue&type=template&id=1be4d8ee&"
import script from "./Danzhangtihuan.vue?vue&type=script&lang=js&"
export * from "./Danzhangtihuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports